module.exports = __webpack_public_path__ + "static/media/left-arrow-bars-with-group.5beac7a2.svg";